<template>
    <div class="form-group">
        <label :for="id.ID()" :class="{'sr-only': srOnly}">
            <slot name="label">{{ label }}</slot>
        </label>
		<div
			class="pseudo-input"
		>
			<input
				:id="id.ID()"
				:aria-label="label"
				type="search"
				class="input-bare w-full flex-1"
				placeholder="Select"
				v-if="!innerValue.length"
				@click="selectSearch"
				@keyup.enter="selectSearch"
			/>
			<span
				class="badge badge-secondary badge-sm mr-2 mb-2"
				v-for="(item, index) in innerValue"
				v-bind:key="index"
			>
				{{getGradeValueCaption(item)}}
				<a @click="removeValue(item)"><b-icon icon="x"></b-icon></a>
			</span>
			<span
				class="badge badge-primary badge-sm mr-2 mb-2"
				v-if="innerValue.length"
				@click="selectSearch()"
			>
				<b-icon icon="plus"></b-icon> {{ $t("add") }}
			</span>
		</div>
    </div>
</template>

<script>
import id from 'src/modules/uuid.js'

export default {
    props: {
        label: {
            type: String,
            required: true,
        },
        srOnly: { // If true, hides label except as an aria-label for screen-readers.
            type: Boolean,
            default: false,
        },
        value: Array,
        options: [Array, Object],
        optionLabel: String,    // Use with objects to specify the label field
        optionCaption: String,    // Use with objects to specify the caption field
        optionValue: String,    // Use with objects to specify the value field
        indexIsValue: {   // Set this to true if you wish to use the v-for index as the value.
            type: Boolean,
            default: false,
        },
        labelCb: Function,  // Called on the options to set their label // NOT IMPLEMENTED
        valueCb: Function,  // Called on the options to set their value // NOT IMPLEMENTED
        nullable: {
            type: Boolean,
            default: true,
        },
        nullLabel: {
            type: String,
            default: '',
        },
        error: Boolean,
    },
    data() {
        return {
            id: new id(),
            innerValue: this.value || [],
        }
    },
    watch: {
    	value: function() {
    		this.innerValue = this.value;
    	},
    },
    methods: {
        selectSearch() {
			const self = this;
			var options = JSON.parse(JSON.stringify(this.options));
			this.$store.commit("openModal", {
				type: "selector",
				title: this.label,
				selectCallback: function(selection) {
					for (let i = 0; i < self.innerValue.length; i++) {
						if(self.innerValue[i][self.optionValue] == selection[self.optionValue]){
							self.innerValue.splice(i, 1);
							self.$emit('input', self.innerValue);
							return;
						}
					};
					self.innerValue.push(selection);
           			self.$emit('input', self.innerValue);
           			return;
				},
				selected: this.innerValue,
				data: options,
				captionKey: this.optionLabel,
                subcaptionKey: this.optionCaption
			});
        },
		removeValue(selection) {
			var index = this.innerValue.indexOf(selection);
			if (index > -1) {
				this.innerValue.splice(index, 1);
				this.$emit('input', this.innerValue);
			}
			/*
			this.innerValue.forEach((item, i) => {
				if (item === selection) {
					this.$delete(this.innerValue, i);
					this.$emit('input', self.innerValue);
				}
			});
			*/
		},
    	getGradeValueCaption(item){
    		return item[this.optionLabel];
    	}
    },
    computed: {
    }
}
</script>
